import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
import slick from 'slick-carousel';

$(window).on('load',function(){
	let autospeed = 5000;
	let speed = 1000;
	$('.hero-slider').each(function(){
		$(this).slick({
			infinite: false,
			arrows: false,
			dots: true,
			autoplay: false,
			autoplaySpeed: autospeed,
			speed: speed,
			infinite: true,
			rows:0,
			slidesToShow: 1,
			swipeToSlide:true,
			pauseOnFocus:true,
			pauseOnHover:true,
			slidesToScroll: 1,
			accessibility: true,
			focusOnSelect: true,
		});
		
		let heroContainer = $(this).closest('.hero-slider-container');		

		$(this).on('setPosition', function(event, slick, currentSlide, nextSlide) {
			var $video = $(this).find('.slick-current video');
			if ($video.length) {
				var video = $video[0];
				slick.options.autoplaySpeed = video.duration * 1000;
				video.currentTime = 0;
				video.play();
				
				// Timeline: setze individuelle Übergangsdauer für Progressbar bei Video
				// let videoSlide = $(this).find('.slick-current').data('slickIndex');
				// heroContainer.find('span[data-slick-index="'+videoSlide+'"]').children('span').css({
				// 	'transition-duration': video.duration+'s'
				// });
			} 
			else {
				slick.options.autoplaySpeed = autospeed;
			}
			
			let slideIndex = $(this).find('.slick-current').data('slickIndex');

			
			heroContainer.find('span:not([data-slick-index="'+slideIndex+'"])').parent().removeClass('active');
			heroContainer.find('span[data-slick-index="'+slideIndex+'"]').parent().addClass('active');			
		});

		$(this).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			var $video = $(this).find('.slick-current video');
			if ($video.length) {
				var video = $video[0];
				video.pause();
				video.currentTime = 0;
			} 
		});

		// Timeline: initial aktiven Dot markieren
		// heroContainer.find('span[data-slick-index="0"]').parent().addClass('active');

		// Timeline: setze anfängliche Progressbar-Animation
		// heroContainer.find('span[data-slick-index]').children('span').css({
		// 	'transition-duration': autospeed+'ms'
		// });

	
		heroContainer.find('.progressbar-container div').on('click', function () {
			var goToThisIndex = $(this).find("span").data("slickIndex");
			heroContainer.find('.slick-dots li:nth-child('+(goToThisIndex+1)+')').trigger('click');
		});
	});

	$('.hero-slider-subpage').each(function(){
		$(this).slick({
			infinite: false,
			arrows: false,
			dots: false,
			autoplay: false,
			speed: 1000,
			rows:0,
			slidesToShow: 1,
			swipeToSlide:true,
			slidesToScroll: 1,
			focusOnSelect:true,
			pauseOnFocus:true
		});
		$(this).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			var $currentSlide = $(slick.$slides.get(nextSlide));
			var $video = $currentSlide.find('video');
			if ($video.length) {
				var video = $video[0];
				slick.options.autoplaySpeed = video.duration * 1000;
			} 
			else {
				slick.options.autoplaySpeed = 3000;
			}
		});
	});

	function enable_ratiochecker (){

		function check_16by9(){
			let videos = document.getElementsByClassName ("hero-video");
			let numvideos = videos.length;
	
			for (let i=0; i<numvideos; i++) {
				if((videos[i].offsetWidth / videos[i].offsetHeight) >= (16/9)){
					videos[i].classList.add("ratio16by9");
				} else {
					videos[i].classList.remove("ratio16by9");
				}
			}
		}
	
		window.addEventListener('resize', function(event) {
			check_16by9();
		}, true);
	
		check_16by9();
	
	};
	
	if (document.getElementsByClassName("hero-video").length > 0) {
		enable_ratiochecker();
	}
});






$('.hero-slider').each(function () {
	const $slider = $(this);
	let isKeyboardNavigation = false;

	// Eingabemodus lokal für diesen Slider erfassen
	$slider.on('keydown', function (event) {
		if (event.key === 'Tab' || event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
			isKeyboardNavigation = true;
		}
	});

	$slider.on('mousedown', function () {
		isKeyboardNavigation = false;
	});

	// Fokus nur setzen, wenn per Tastatur navigiert wurde
	$slider.on('afterChange', function (event, slick, currentSlide) {
		if (!isKeyboardNavigation) return;

		const $currentSlide = $(slick.$slides.get(currentSlide));

		// 1. Link im Slide fokussieren
		const $firstLink = $currentSlide.find('a').first();
		if ($firstLink.length) {
			$firstLink.focus();
		} else {
			// 2. Oder h2 fokussieren
			const $heading = $currentSlide.find('h2').first();
			if ($heading.length) {
				if (!$heading.is('[tabindex]')) {
					$heading.attr('tabindex', '-1');
				}
				$heading.focus();
			}
		}
	});
});
